module.exports = __webpack_public_path__ + "img/btn-dec.af9f716a.png";